module.exports = __webpack_public_path__ + "static/media/blom-pysanky-thumb-81.8da96ce6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-thumb-81.jpg
// module id = 4042
// module chunks = 13